import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-20'],
  },
  pageDescription: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.secondaryBackground,
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-16'],
    padding: anatomy['size-16'],
    background: colors.brandGhostBackground,
    borderRadius: anatomy.borderRadiusM,
    maxWidth: '100%',
  },
  form: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-4'],
    color: colors.primaryText,
  },
  date: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightBody-5'],
    color: colors.tertiaryText,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionsRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: anatomy['space-20'],
  },
  action: {
    display: 'flex',
    gap: anatomy['space-4'],
    alignItems: 'center',
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightBody-5'],
    color: colors.primaryText,
    width: 'min-content',
    whiteSpace: 'nowrap',
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  actionAccent: {
    color: colors.accentText,
  },
  watch: {
    color: colors.tertiaryText,
  },
});
